var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-91a)" },
      React.createElement("rect", { width: "40", height: "40", rx: "20", fill: "#1877F2" }),
      React.createElement("path", { d: "M17.7013 30H21.6666L21.6667 20.1414H24.6553L24.9474 16.9316H21.6668V14.7535C21.6668 13.5749 22.2155 13.1486 23.6208 13.1486H25V10.1681C25 10.1681 23.6869 10 22.8505 10C18.8959 10 17.7012 11.9411 17.7012 14.6476V16.9316H15V20.1414H17.7013V30Z", fill: "#fff" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-91a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H40V40H0z" })
      )
    )
  );
});